module.exports = __webpack_public_path__ + "./fonts/elite-lab-icon.53f498e90f2360a208df35da63d04d33.svg";